import axios, { AxiosInstance, AxiosError } from 'axios';
import { FundraisingAssetAvatar } from '../../models/fundraising-asset-avatar.model';
import { FundraisingAssetProject } from '../../models/fundraising-asset-project.model';

export interface FundraisingAssetsResponse {
  Project: FundraisingAssetProject[];
  Avatar: FundraisingAssetAvatar[];
}

type Response = FundraisingAssetsResponse & AxiosError;

const apiClient = (): AxiosInstance => {
  return axios.create({
    headers: {
      'Content-type': 'application/json',
    },
  });
};

export const fundraisingAssetService = async (): Promise<Response> => {
  try {
    const assetsUrl = getAssetsUrl();
    const response = await apiClient().get(assetsUrl);
    return response.data as Response;
  } catch (errorResponse) {
    const error = errorResponse as Response;
    return error;
  }
};

const getAssetsUrl = (): string => {
  const host = document.getElementById('app')?.getAttribute('data-host') ?? '';
  const assetsPath = getAssetsPath('default');

  // let assetsPath = '';
  // switch (host) {
  //   case host.match(/prod.acquia-sites.com$/)?.input:
  //   case 'marysmeals.lndo.site':
  //   default:
  //     assetsPath = getAssetsPath('default');
  //     break;
  //   case host.match(/marysmeals.pl$/)?.input:
  //   case 'marysmeals-poland.lndo.site':
  //     assetsPath = getAssetsPath('poland');
  //     break;
  //   case host.match(/marysmeals.org.uk$/)?.input:
  //   case 'marysmeals-uk.lndo.site':
  //     assetsPath = getAssetsPath('uk');
  //     break;
  // }

  return `//${host}/${assetsPath}`;
};

const getAssetsPath = (siteId: string): string => {
  return `sites/${siteId}/files/fundraising_assets/fundraising-assets.json`;
};
